export default "<!-- Excel-export-PreLoader -->\n<div class=\"excel-export-loader\">\n    <div class=\"loader\"></div>\n</div>\n"